import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { usuario, logout, ehPremium, ehAdmin } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [aberto, setAberto] = useState(false);
  const navRef = useRef(null);

  const handleLogout = () => { logout(); nav('/'); setAberto(false); };
  const fechar = () => setAberto(false);

  // Fecha ao navegar
  useEffect(() => { fechar(); }, [location]);

  // Fecha ao clicar fora
  useEffect(() => {
    const handler = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) fechar();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Trava scroll do body quando menu aberto no mobile
  useEffect(() => {
    document.body.style.overflow = aberto ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [aberto]);

  const linksVisitante = (
    <>
      <li><Link to="/#como-funciona" onClick={fechar}>Como funciona</Link></li>
      <li><Link to="/planos" onClick={fechar}>Planos</Link></li>
      <li><Link to="/login" onClick={fechar}>Entrar</Link></li>
      <li><Link to="/cadastro" className="btn-cta" onClick={fechar}>Assinar</Link></li>
    </>
  );

  const linksUsuario = (
    <>
      <li><Link to="/veiculos" onClick={fechar}>Comprar veículos</Link></li>
      {ehPremium() && <li><Link to="/vender" onClick={fechar}>Vender / Anunciar</Link></li>}
      <li><Link to="/produtos" onClick={fechar}>Produtos</Link></li>
      <li><Link to="/minha-assinatura" onClick={fechar}>Minha assinatura</Link></li>
      <li><Link to="/perfil" onClick={fechar}>Perfil</Link></li>
      <li>
        <button className="btn btn-outline btn-sm" onClick={handleLogout}>Sair</button>
      </li>
    </>
  );

  const linksAdmin = (
    <>
      <li><Link to="/admin" onClick={fechar}>Dashboard</Link></li>
      <li><Link to="/admin/veiculos" onClick={fechar}>Veículos</Link></li>
      <li><Link to="/admin/solicitacoes" onClick={fechar}>Solicitações</Link></li>
      <li>
        <button className="btn btn-outline btn-sm" onClick={handleLogout}>Sair</button>
      </li>
    </>
  );

  return (
    <nav className="navbar" ref={navRef}>
      <Link to="/" className="logo" onClick={fechar}>
        <img src="/assets/heritage-logo-transparent.png" alt="Heritage" className="logo-mark" />
        <span className="logo-name">
          Web Heritage
          <small>Compra e Venda de Antigos</small>
        </span>
      </Link>

      {/* Desktop */}
      <ul className="nav-links nav-desktop">
        {!usuario && linksVisitante}
        {usuario && !ehAdmin() && linksUsuario}
        {ehAdmin() && linksAdmin}
      </ul>

      {/* Hamburger */}
      <button
        className={`menu-toggle${aberto ? ' ativo' : ''}`}
        onClick={() => setAberto(v => !v)}
        aria-label="Menu"
        aria-expanded={aberto}
      >
        <span /><span /><span />
      </button>

      {/* Mobile overlay */}
      {aberto && <div className="nav-overlay" onClick={fechar} />}

      {/* Mobile drawer */}
      <ul className={`nav-links nav-mobile${aberto ? ' aberto' : ''}`}>
        {!usuario && linksVisitante}
        {usuario && !ehAdmin() && linksUsuario}
        {ehAdmin() && linksAdmin}
      </ul>
    </nav>
  );
}
